module.exports = __webpack_public_path__ + "static/media/997823.b267f0a7.png";